var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card widget-report-radar"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body bg-white pt-0"},[_c('RadarChart',{ref:"radar",attrs:{"user-id":_vm.userId}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header bg-white"},[_c('h5',{staticClass:"text-primary font-weight-bold"},[_vm._v("Évolution de ma qualité de vie par date")])])
}]

export { render, staticRenderFns }